
import { useState, useEffect } from "react";
import { NavLink, useLocation, Link } from "react-router-dom";
import { Sun, Moon } from "lucide-react";

const Header = () => {
  const [isDarkMode, setIsDarkMode] = useState(false);
  const location = useLocation();

  // Check if dark mode is saved in localStorage
  useEffect(() => {
    const savedMode = localStorage.getItem("darkMode");
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    
    if (savedMode !== null) {
      setIsDarkMode(savedMode === "true");
    } else {
      setIsDarkMode(prefersDark);
    }
  }, []);

  // Update document class and localStorage when dark mode changes
  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add("dark");
    } else {
      document.documentElement.classList.remove("dark");
    }
    localStorage.setItem("darkMode", isDarkMode.toString());
  }, [isDarkMode]);

  const toggleDarkMode = () => {
    setIsDarkMode((prev) => !prev);
  };

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="w-full pt-8 pb-6 mb-12 flex flex-col items-center justify-center animate-fade-in">
      <div className="absolute right-8 top-8">
        <button
          onClick={toggleDarkMode}
          className="p-2 rounded-full transition-all duration-300 hover:bg-secondary"
          aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
        >
          {isDarkMode ? (
            <Sun className="h-5 w-5 transition-all duration-300" />
          ) : (
            <Moon className="h-5 w-5 transition-all duration-300" />
          )}
        </button>
      </div>
      
      <div className="flex flex-col items-center justify-center mb-8">
        <Link to="/" className="transition-opacity hover:opacity-80">
          <h1 className="text-3xl font-medium mb-1">YURI LOBO</h1>
        </Link>
        <p className="text-sm text-muted-foreground">Video Editor & Motion Designer</p>
      </div>
      
      <nav className="flex items-center space-x-8 text-sm font-medium">
        <NavLink 
          to="/" 
          className={`nav-link ${isActive("/") ? "active" : ""}`}
          end
        >
          Home
        </NavLink>
        <NavLink 
          to="/work" 
          className={`nav-link ${isActive("/work") ? "active" : ""}`}
        >
          Work
        </NavLink>
        <NavLink 
          to="/about" 
          className={`nav-link ${isActive("/about") ? "active" : ""}`}
        >
          About
        </NavLink>
        <NavLink 
          to="/contact" 
          className={`nav-link ${isActive("/contact") ? "active" : ""}`}
        >
          Contact
        </NavLink>
      </nav>
    </header>
  );
};

export default Header;
